import SystemMessages from './SystemMessages';
import './SystemMessages.scss';

export default SystemMessages;
